import types from './types';
import get from 'lodash/get';

import {geodetails} from '~/misc/geocoding';
import {promiseAction} from '~/misc/dispatch';

export const loadPlace = (place) => (dispatch, getState) => {
  const state = getState();

  if (get(state, ['places', place.place_id, 'data'])) {
    return Promise.resolve(true);
  }

  return promiseAction(dispatch, getState, types.PLACE_LOADED, geodetails(place), place.place_id);
};



// WEBPACK FOOTER //
// ./src/modules/places/actions.js